import React, { useEffect, useState } from "react";
import { Placeholder, Segment, SegmentGroup, Table } from "semantic-ui-react";
import { useParams } from "react-router-dom";
import {
  actualizarRatificacion,
  cargarCalificacion,
  cargarCalificacionFinal,
} from "../../utils/Datos";
import { useForm } from "../../hooks/useForm";
import Swal from "sweetalert2";

export const FormularioCalificacionEditable = ({
  id_participant,
  mostrarBoton = true,
  setcalificacionEditada=null,
  setfinalizar=null,
  finalizar=null
}) => {
  const [calificacion, setcalificacion] = useState(null);
  const [valoresForm, handleInputChange, reset, updateValue, updateState] =
    useForm({});

  useEffect(() => {
    if (calificacion!=null && finalizar!=null) {
      console.log('calificacion');
      setfinalizar({
        id_qualifications: calificacion.id_qualifications,
        volumeOfWork: calificacion.volumeOfWork,
        speedInExecution: calificacion.speedInExecution,
        opportunityInExecution: calificacion.opportunityInExecution,
        planningWork: calificacion.planningWork,
        abilityToExecute: calificacion.abilityToExecute,
        jobKnowledge: calificacion.jobKnowledge,
        studies: calificacion.studies,
        serviceCapacity: calificacion.serviceCapacity,
        trainingVolunteer: calificacion.trainingVolunteer,
        creativityToSolveProblems: calificacion.creativityToSolveProblems,
        easyIntegration: calificacion.easyIntegration,
        permanency: calificacion.permanency,
        punctuality: calificacion.punctuality,
        standardsCompliance: calificacion.standardsCompliance,
        taskFulfillment: calificacion.taskFulfillment,
        appeal:{
          ...finalizar.appeal
        }
      })
    }
  }, [calificacion])
  

  useEffect(() => {
    console.log("Calificacion fiunal " + id_participant);
    cargarCalificacionFinal(id_participant).then((c) => {
      console.log("Calificacion fiunal " + id_participant + " Fin ");
      if (c.status) {
        setcalificacion(c.datos);
        //updateValue("",c.datos)
      }
    });
  }, [id_participant]);

  const handleActualizar = () => {
    actualizarRatificacion(calificacion).then((r) => {
      if (r.status) {
        Swal.fire({
          icon: "success",
          title: "Correcto",
          text: "Se han actualizado los datos correctamente",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Ha ocurrido un error al enviar los datos " + r.errores[0],
        });
      }
    });
  };

  useEffect(() => {
    if (setcalificacionEditada!==null) {
      setcalificacionEditada(calificacion);
    }
  }, [calificacion])
  

  return calificacion === null ? (
    <Placeholder>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
    </Placeholder>
  ) : (
    <>
      <h2>{calificacion.name}</h2>
      <Segment.Group className="mb-3">
        <Segment inverted color="blue">
          <h4 className="text-white">1) FACTOR RENDIMIENTO</h4>
        </Segment>
        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>a) Cantidad de Trabajo</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={6}>
                  Notas Concepto
                </Table.HeaderCell>
                {/*<Table.HeaderCell textAlign='center'>Notas SubFactor</Table.HeaderCell>*/}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">Volumen de trabajo</Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.volumeOfWork}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        volumeOfWork: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          volumeOfWork:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Rapidez en la ejecución del trabajo
                </Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.speedInExecution}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        speedInExecution: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          speedInExecution:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Oportunidad en la ejecución del trabajo
                </Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.opportunityInExecution}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        opportunityInExecution: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          opportunityInExecution:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 3 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <b>
                    {(parseInt(calificacion.volumeOfWork) || 0) +
                      (parseInt(calificacion.speedInExecution) || 0) +
                      (parseInt(calificacion.opportunityInExecution) || 0)}
                  </b>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b>
            <input
              type="text"
              value={calificacion.commentSF11}
              className="form-control"
              onChange={(e) => {
                console.log(calificacion);
                setcalificacion({
                  ...calificacion,
                  commentSF11: e.target.value,
                });
              }}
            ></input>
          </p>
        </Segment>

        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>b) Calidad de la Labor Realizada</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={6}>
                  Notas Concepto
                </Table.HeaderCell>
                {/*<Table.HeaderCell textAlign='center'>Notas SubFactor</Table.HeaderCell>*/}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Planificación del trabajo
                </Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.planningWork}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        planningWork: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          planningWork:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Habilidad en la ejecución del trabajo (ausencia de errores)
                </Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.abilityToExecute}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        abilityToExecute: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          abilityToExecute:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 2 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <b>
                    {(parseInt(calificacion.planningWork) || 0) +
                      (parseInt(calificacion.abilityToExecute) || 0)}
                  </b>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b>{" "}
            <input
              type="text"
              value={calificacion.commentSF12}
              className="form-control"
              onChange={(e) => {
                console.log(calificacion);
                setcalificacion({
                  ...calificacion,
                  commentSF12: e.target.value,
                });
              }}
            ></input>
          </p>
        </Segment>
      </Segment.Group>

      <Segment.Group>
        <Segment inverted color="blue">
          <h4 className="text-white">{`2) FACTOR CONDICIONES PERSONALES`}</h4>
        </Segment>
        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>c) Conocimiento del Trabajo</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={6}>
                  Notas Concepto
                </Table.HeaderCell>
                {/*<Table.HeaderCell textAlign='center'>Notas SubFactor</Table.HeaderCell>*/}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Conocimiento del trabajo
                </Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.jobKnowledge}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        jobKnowledge: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          jobKnowledge:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">Estudios</Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.studies}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        studies: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          studies:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Capacidad de servicio relacionada con su función
                </Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.serviceCapacity}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        serviceCapacity: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          serviceCapacity:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 3 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <b>
                    {(parseInt(calificacion.jobKnowledge) || 0) +
                      (parseInt(calificacion.studies) || 0) +
                      (parseInt(calificacion.serviceCapacity) || 0)}
                  </b>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b>
            <input
              type="text"
              value={calificacion.commentSF21}
              className="form-control"
              onChange={(e) => {
                console.log(calificacion);
                setcalificacion({
                  ...calificacion,
                  commentSF21: e.target.value,
                });
              }}
            ></input>
          </p>
        </Segment>

        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>d) Interés por el trabajo que realiza</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={6}>
                  Notas Concepto
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Capacitación voluntaria directamente relacionada con su
                  función
                </Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.trainingVolunteer}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        trainingVolunteer: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          trainingVolunteer:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell textAlign="center">
                  Creatividad para solucionar problemas
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <b>
                    <input
                      type="number"
                      max={7}
                      value={calificacion.creativityToSolveProblems}
                      className="form-control"
                      onChange={(e) => {
                        console.log(calificacion);
                        setcalificacion({
                          ...calificacion,
                          creativityToSolveProblems: e.target.value,
                        });
                        if (setfinalizar!=null) {
                          setfinalizar({
                            ...finalizar,
                            creativityToSolveProblems:e.target.value
                          })
                        }
                      }}
                    ></input>
                  </b>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 2 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <b>
                    {(parseInt(calificacion.trainingVolunteer) || 0) +
                      (parseInt(calificacion.creativityToSolveProblems) || 0)}
                  </b>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b>
            <input
              type="text"
              value={calificacion.commentSF22}
              className="form-control"
              onChange={(e) => {
                console.log(calificacion);
                setcalificacion({
                  ...calificacion,
                  commentSF22: e.target.value,
                });
              }}
            ></input>
          </p>
        </Segment>

        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>e) Capacidad de realizar trabajos en grupo</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={6}>
                  Notas Concepto
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Facilidad de integración al equipo de trabajo
                </Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.easyIntegration}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        easyIntegration: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          easyIntegration:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b>
            <input
              type="text"
              value={calificacion.commentSF23}
              className="form-control"
              onChange={(e) => {
                console.log(calificacion);
                setcalificacion({
                  ...calificacion,
                  commentSF23: e.target.value,
                });
              }}
            ></input>
          </p>
        </Segment>
      </Segment.Group>

      <Segment.Group>
        <Segment inverted color="blue">
          <h4 className="text-white">{`3) FACTOR DE COMPORTAMIENTO FUNCIONARIO`}</h4>
        </Segment>
        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>f) Asistencia y puntualidad</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={6}>
                  Notas Concepto
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">Permanencia</Table.Cell>
                <Table.Cell textAlign="center" warning>
                <input
                    type="number"
                    max={7}
                    value={calificacion.permanency}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        permanency: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          permanency:e.target.value
                        })
                      }
                    }}
                  ></input>
                 
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">Puntualidad</Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.punctuality}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        punctuality: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          punctuality:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 2 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <b>
                    {(parseInt(calificacion.permanency) || 0) +
                      (parseInt(calificacion.punctuality) || 0)}
                  </b>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b>{" "}
            <input
              type="text"
              value={calificacion.commentSF31}
              className="form-control"
              onChange={(e) => {
                console.log(calificacion);
                setcalificacion({
                  ...calificacion,
                  commentSF31: e.target.value,
                });
              }}
            ></input>
          </p>
        </Segment>

        <Segment>
          <Table celled structured>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center" width={10}>
                  <h5>g) Cumplimiento de normas e instrucciones</h5>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={6}>
                  Notas Concepto
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign="center">
                  Cumplimiento de normas
                </Table.Cell>
                <Table.Cell textAlign="center" warning>
                  <input
                    type="number"
                    max={7}
                    value={calificacion.standardsCompliance}
                    className="form-control"
                    onChange={(e) => {
                      console.log(calificacion);
                      setcalificacion({
                        ...calificacion,
                        standardsCompliance: e.target.value,
                      });
                      if (setfinalizar!=null) {
                        setfinalizar({
                          ...finalizar,
                          standardsCompliance:e.target.value
                        })
                      }
                    }}
                  ></input>
                </Table.Cell>
              </Table.Row>

              <Table.Row>
                <Table.Cell textAlign="center">
                  Cumplimiento de tareas
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <b>
                    <input
                      type="number"
                      max={7}
                      value={calificacion.taskFulfillment}
                      className="form-control"
                      onChange={(e) => {
                        console.log(calificacion);
                        setcalificacion({
                          ...calificacion,
                          taskFulfillment: e.target.value,
                        });
                        if (setfinalizar!=null) {
                          setfinalizar({
                            ...finalizar,
                            taskFulfillment:e.target.value
                          })
                        }
                      }}
                    ></input>
                  </b>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell textAlign="center">
                  <b>Suma de 2 conceptos evaluados</b>
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <b>
                    {(parseInt(calificacion.standardsCompliance) || 0) +
                      (parseInt(calificacion.taskFulfillment) || 0)}
                  </b>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
        <Segment>
          <p>
            <b>Comentarios:</b>{" "}
            <input
              type="text"
              value={calificacion.commentSF32}
              className="form-control"
              onChange={(e) => {
                console.log(calificacion);
                setcalificacion({
                  ...calificacion,
                  commentSF32: e.target.value,
                });
              }}
            ></input>
          </p>
        </Segment>
        {mostrarBoton ? (
          <Segment.Group horizontal>
            <Segment>
              <button onClick={handleActualizar} className="btn btn-primary">
                Actualizar calificación
              </button>
            </Segment>
          </Segment.Group>
        ) : (
          <></>
        )}
      </Segment.Group>
    </>
  );
};
